import React from "react";

export const EditorCoverImageContext =
  React.createContext<(url: string) => void>(null);

export function useEditorCoverImage(): any {
  return React.useContext(EditorCoverImageContext);
}
